module.exports = __webpack_public_path__ + "img/header-pessoa-empresa.3609ffcf.png";